<template>
  <div class="position-relative">
    <div>
      <div class="overall-bg pb-0">
        <b-container>
          <b-row>
            <b-col>
              <BacktoPage :goback="$router.back"></BacktoPage>
              <b-row>
                <b-col lg="2" class="field py-4">
                  <label class="mb-0">{{ $t("PurchaseRequest.Code") }}</label>
                  <p class="">{{ details.DocNo }}</p>
                </b-col>
                <b-col lg="2" class="field py-4">
                  <label class=" mb-0">{{ $t("PurchaseRequest.Date") }}</label>
                  <p class="">{{ details.DocDate }}</p>
                </b-col>
                <b-col lg="2" class="field py-4">
                  <label class=" mb-0">{{ $t("PurchaseRequest.RequestedBy") }}</label>
                  <p class="">{{ details.CreatedByName }}</p>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <div class='field' v-if="uploadedTableList.length != 0">
            <label class=" mb-0">{{ $t("PurchaseRequest.QuotationFile") }}</label>
          </div>
          <b-row>
            <b-col lg="3" md="4" sm="6" cols="12" class="d-flex" v-for="item in uploadedTableList">
              <div class="fileuploadcard my-2" :title="item.fileName">
                <div>
                  <p class="filenametxt">{{ item.fileName }}</p>
                  <div class="blue-txt" id="file-name" @click="fileviewer(item.fullPath)">
                    view </div>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-container>
      </div>
      <section class="details_collapse">
        <b-container fluid>
          <b-row>
            <b-col>
              <p v-b-toggle.collapse-details variant="primary" class="float-end mb-3 pe-3">
                <span class="when-open">Collapse Flow Chart</span><span class="when-closed">Expand Flow Chart</span>
              </p>
            </b-col>
          </b-row>
        </b-container>
        <b-collapse id="collapse-details" class="mt-2">
          <BlackCard v-model="data_insert" :loading="loading" />
        </b-collapse>
      </section>

      <div class="overall-bg pt-0">
        <b-container class="form-white-bg">
          <div class="common-heading1 mb-4">Items part of the request</div>
          <TabView class="tabview-custom" ref="tabview4" :scrollable="true">
            <TabPanel>
              <template #header>
                <i class="pi pi-align-left pe-3" :class="ObjVal2.arraylenght > 0 ? '' : 'withoutbadge'"></i>
                <span :class="ObjVal2.arraylenght > 0 ? '' : 'withoutbadge'">Items
                  <Badge :value="ObjVal2.arraylenght" severity="warning" v-if="ObjVal2.arraylenght > 0"></Badge>
                </span>
              </template>
              <div>
                <PiItemTblview v-model="ObjVal2"></PiItemTblview>
              </div>
            </TabPanel>
            <TabPanel>
              <template #header>
                <i class="pi pi-align-left pe-3" :class="ObjVal.arraylenght > 0 ? '' : 'withoutbadge'"></i>
                <span :class="ObjVal.arraylenght > 0 ? '' : 'withoutbadge'">Quote
                  <Badge :value="ObjVal.arraylenght" severity="warning" v-if="ObjVal.arraylenght > 0"></Badge>
                </span>
              </template>
              <div>
                <QuotesTableview v-model="ObjVal"></QuotesTableview>
              </div>
            </TabPanel>
            <TabPanel>
              <template #header>
                <i class="pi pi-align-left pe-3" :class="ObjVal1.arraylenght > 0 ? '' : 'withoutbadge'"></i>
                <span :class="ObjVal1.arraylenght > 0 ? '' : 'withoutbadge'">PO
                  <Badge :value="ObjVal1.arraylenght" severity="warning" v-if="ObjVal1.arraylenght > 0"></Badge>
                </span>
              </template>
              <div>
                <POTableview v-model="ObjVal1" />
              </div>
            </TabPanel>
            <TabPanel>
              <template #header>
                <i class="pi pi-align-left pe-3" :class="ObjVal5.arraylenght > 0 ? '' : 'withoutbadge'"></i>
                <span :class="ObjVal5.arraylenght > 0 ? '' : 'withoutbadge'">GRN
                  <Badge :value="ObjVal5.arraylenght" severity="warning" v-if="ObjVal5.arraylenght > 0"></Badge>
                </span>
              </template>
              <div>
                <GrnTable v-model="ObjVal5"></GrnTable>
              </div>
            </TabPanel>
            <TabPanel>
              <template #header>
                <i class="pi pi-align-left pe-3" :class="ObjVal4.arraylenght > 0 ? '' : 'withoutbadge'"></i>
                <span :class="ObjVal4.arraylenght > 0 ? '' : 'withoutbadge'">Logs
                  <Badge :value="ObjVal4.arraylenght" severity="warning" v-if="ObjVal4.arraylenght > 0"></Badge>
                </span>
              </template>
              <div class="logcard" v-for="item in headers">
                <Log />
              </div>
            </TabPanel>
          </TabView>
        </b-container>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import BacktoPage from "../../../../../../components/FormComponents/BacktoMaster.vue";
import { FilterMatchMode, FilterOperator } from "primevue/api";
import Tableview from "../../../../../../components/FormComponents/NormalTable.vue";
import Log from "../../../../../../modules/Inventory/components/MasterDetails/TabsPage/Log.vue";
import POTableview from "../../../../../../modules/Inventory/pages/Transaction/PurchaseOrder/POTable.vue";
import PiItemTblview from "./PiItemTblview.vue";
import QuotesTableview from "../quotes/QuotesTableview.vue";
import GrnTable from  "../../../../../../modules/Inventory/pages/Transaction/stockin/grn/GrnTable.vue";
import GrnReturnTableview from  "../../../../../../modules/Inventory/pages/Transaction/StockOut/grnreturn/GrnReturnTableview.vue";
import BlackCard from "../../../../../../components/Chart/PIFlowChart.vue";
import Loader from "../../../../../../components/FormComponents/Loader.vue";
import commonService from  "../../../../../../modules/Inventory/Service/WithoutStockAffectService";
import StockWOFileUploadServices from  "../../../../../../modules/Inventory/Service/StockWOFileUploadService";

export default defineComponent({
  components: {
    BacktoPage,
    Tableview,
    Log,
    POTableview,
    PiItemTblview,
    QuotesTableview,
    GrnTable,
    GrnReturnTableview,
    BlackCard,
    Loader,
  },
  setup() {
    const route = useRoute();
    const routers = useRouter();
    let QueryStringValue: any = route.query;

    let loading = ref(false);

    let data_insert = ref({
      poarraylenght: 0,
      Qarraylenght: 0,
      grnarraylenght: 0,
    });
    let ObjVal = ref({
      arraylenght: 0,
    });

    let ObjVal1 = ref({
      arraylenght: 0,
    });

    let ObjVal2 = ref({
      arraylenght: 0,
    });
    let ObjVal3 = ref({
      DocNo: 0,
    });
    let ObjVal4 = ref({
      arraylenght: 0,
    });
    let ObjVal5 = ref({
      arraylenght: 0,
    });

    let details: any = ref({
      SupplierId: 0,
      Price: "",
      PRdate: "",
      Paymentterms: "",
      DeliveryTerms: "",
      DocNo: "",
      RefNo: "",
      SupplierName: "",
      Address: "",
      suppliername: "",
      GST: "",
      DocType: "",
      StoreId: 0,
      PRstatus: 0,
      CreatedAt: "",
      ItemCount: 0,
    });

    let approvaldetails: any = ref({
      HeaderName: "PI",
      ContentName: "Purchase Indent",
      ApprovalCode: 0,
      ApprovalDate: "",
      ApprovalPrice: 0,
      CreatedAt: "",
    });

    onMounted(() => {
      PIDetails();
    });

    watch(
      () => ObjVal.value,
      (newVal) => {
        debugger;
        loading.value = true;
        data_insert.value.Qarraylenght = Number(newVal.arraylenght);
        loading.value = false;
      }
    );

    watch(
      () => ObjVal1.value,
      (newVal) => {
        debugger;
        data_insert.value.poarraylenght = Number(newVal.arraylenght);
      }
    );

    watch(
      () => ObjVal5.value,
      (newVal) => {
        debugger;

        data_insert.value.grnarraylenght = Number(newVal.arraylenght);
      }
    );
    const menu = ref();
    const action = ref([
      {
        items: [
          {
            label: "Close the request",
          },
        ],
      },
    ]);

    const toggle = (event: MouseEvent) => {
      menu.value.toggle(event);
    };
    const headers = [
      {
        header: "Category",
        field: "ItemCategory1",
      },
      {
        header: "Item #",
        field: "ItemCode",
      },

      {
        header: "Item name",
        field: "Itemname1",
      },
      {
        header: "Quantity",
        field: "ItemQuantity",
      },
      {
        header: "Pack Size",
        field: "PackSizename1",
      },

      {
        header: "unit rate",
        field: "unit rate",
      },

      {
        field: "action", header: "Action", slot: "action",
        frozencolumn: true, sortable: false
      },
    ];
    let uploadedTableList: any = ref([])
    function fileviewer(data) {
      debugger
      const newTabUrl = data;
      window.open(newTabUrl, '_blank');
    }
    const globalFilterFields = ref(headers.map((col) => col.field));

    const filters = {
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      Name: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
      },
      CreatedAt: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }],
      },
      Code: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
      },
      length: {
        operator: FilterOperator.OR,
        constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
      },
    };

    let items = ref([]);

    async function PIDetails() {
      debugger;
      const response = await commonService.GetByStockWOTransId(
        QueryStringValue["PIId"]
      );
      debugger;
      let data = response["result"][0];
      console.log(data);

      details.value.Price = data.grossamount;
      details.value.SupplierId = data.SupplierId;
      details.value.PRdate = data.DocDate;
      details.value.DocNo = data.DocNo;
      details.value.RefNo = data.RefNo;
      details.value.CreatedAt = data.CreatedAt;

      details.value.DocType = data.DocType;
      details.value.StoreId = data.StoreId;
      details.value.PRstatus = data.Status;

      approvaldetails.value.ApprovalCode = data.DocNo;
      approvaldetails.value.ApprovalDate = data.DocDateHR;
      approvaldetails.value.CreatedAt = data.CreatedAt;
      approvaldetails.value.ApprovalPrice = data.grossamount;

      details.value.DocDate = data.DocDateHR;
      details.value.CreatedByName = data.CreatedByName;
      const FileUploadresult = await StockWOFileUploadServices.getStockWOFileById(
        QueryStringValue["PIId"]
      );
      if (FileUploadresult['result'].length > 0) {
        for (let i = 0; i < FileUploadresult['result'].length; i++) {
          let Fileobj = {};
          (Fileobj["url"] = FileUploadresult['result'][i].FileName.split('/FileUpload/')[1]),
            (Fileobj["fileName"] = FileUploadresult['result'][i].FileName.split('/').pop()),
            (Fileobj["fileType"] = Fileobj["url"].split('/')[0]),
            (Fileobj["fullPath"] = FileUploadresult['result'][i].FileName),
            (Fileobj["Id"] = FileUploadresult['result'][i].Id),
            uploadedTableList.value.push(Fileobj)
        }
      }
      else {
        uploadedTableList.value = [];
      }
    }

    return {
      action,
      toggle,
      menu,
      globalFilterFields,
      items,
      headers,
      filters,
      loading,
      ObjVal,
      ObjVal1,
      ObjVal2,
      ObjVal3,
      ObjVal4,
      ObjVal5,
      data_insert,
      details,
      approvaldetails,
      fileviewer,
      uploadedTableList,
    };
  },
});
</script>

<style lang="scss" scoped>
.tab-icon {
  width: 30px;
}

.blackbg {
  background-color: #303030;
  height: 150px;
}

.withoutbadge {
  padding-top: 5px;
  padding-bottom: 2px;
}
</style>
